$(document).ready(function () {
    $(".accordion:not(.termsItem) .top").click(function () {
        $(this).parent().toggleClass("open");
        if ($(this).parent().hasClass("open")) {
            $(this).next().stop(true).slideDown(250);
        } else {
            $(this).next().stop(true).slideUp(250);
        };
    });
})